export default "__VITE_ASSET__BcBBHLIu__"